import { type Theme } from "@mui/material";
import { dashIfEmpty } from "../../../constants/utils";
import type { ServiceLevel } from "../../../services/prePlanningService.types";

export const formatTrailerTitle = (
  name?: string | null,
  title?: string | null
) =>
  dashIfEmpty(
    name ? name + (title && name !== title ? " " + title : "") : title ?? ""
  );

export const isMexicoLTLService = (
  isMexicoTooltipEnabled: boolean,
  serviceLevel?: ServiceLevel | null
): boolean => serviceLevel === "MXUS-LTL" && isMexicoTooltipEnabled;

export const daysOnHandColors = (
  daysOnHand: number,
  theme: Theme
): { backgroundColor: string; labelColor: string } => {
  const bgColors = {
    late: theme.palette.customError.light,
    warn: theme.palette.customWarning.light,
    early: theme.palette.customSuccess.light,
  };
  const labelColors = {
    late: theme.palette.customError.main,
    warn: theme.palette.customWarning.main,
    early: theme.palette.customSuccess.main,
  };
  if (daysOnHand >= 5) {
    return { backgroundColor: bgColors.late, labelColor: labelColors.late };
  } else if (daysOnHand >= 3) {
    return { backgroundColor: bgColors.warn, labelColor: labelColors.warn };
  } else if (daysOnHand >= 1) {
    return { backgroundColor: bgColors.early, labelColor: labelColors.early };
  } else {
    return {
      backgroundColor: theme.palette.grey[300],
      labelColor: theme.palette.grey[500],
    };
  }
};
